<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <template v-slot:activator="{ on: dialog }">
            <v-btn
                    v-if="!simple && !passive"
                    v-on="dialog"
                    dark
            >
                <v-icon>mdi-plus</v-icon>
                {{ $t('controls.create_radar') }}
            </v-btn>
            <v-tooltip
                    v-else-if="!passive"
                    top
                    :open-delay="tooltipDelay"
            >
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                        v-on="{ ...tooltip, ...dialog}"
                        icon
                    >
                        <v-icon v-if="radar.id === undefined">mdi-plus</v-icon>
                        <v-icon v-else>mdi-cog</v-icon>
                    </v-btn>
                </template>
                <span v-if="radar.id === undefined">{{ $t('controls.tooltip.add_radar') }}</span>
                <span v-else>{{ $t('controls.tooltip.edit_radar') }}</span>
            </v-tooltip>
        </template>

        <RadarForm
            :radar="radar"
            :cancel="true"
            @radarIsProcessed="done"
            @radarIsCanceled="close"
        ></RadarForm>

    </v-dialog>
</template>

<script>
  import RadarForm from './RadarForm'
  import { settings } from '../../settings/settings.js'

  export default {
    name: 'RadarFormDialog',
    components: { RadarForm },
    props: {
      radar: {
        type: Object,
        default () {
          return {}
        }
      },
      simple: {
        type: Boolean,
        default: true
      },
      passive: {
        type: Boolean,
        default: false
      },
      show: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      ...settings,
      dialog: false
    }),

    methods: {
      done () {
        this.dialog = false
      },
      close () {
        this.dialog = false
        this.$emit('close')
      }
    },

    watch: {
      show(status) {
        this.dialog = status
      }
    }
  }
</script>
